import {
	UtilReducer,
	UtilStoreState,
	utilStoreStateInitial,
} from '@Types/utils.types';
import {
	setDataGridState,
	setUniqueSelectedIds,
	setUniqueSelectedStatus,
} from '@Actions';

import { GridInitialState } from '@mui/x-data-grid-premium';
import { createReducer } from '@reduxjs/toolkit';

export interface DataGridStateChange {
	key: string;
	initialState?: GridInitialState;
}

const updateInitialState = (
	state: UtilStoreState,
	action: DataGridStateChange,
) => {
	state.dataGridState[action.key] = action.initialState;
	return state;
};

const reducer: UtilReducer = {
	[setDataGridState.toString()]: (state, action) =>
		updateInitialState(state, action.payload),
	[setUniqueSelectedIds.toString()]: (state, action) => ({
		...state,
		selectedUniqueIds: action.payload,
	}),
	[setUniqueSelectedStatus.toString()]: (state, action) => ({
		...state,
		selectedUniqueStatus: action.payload,
	}),
};

export const utilReducer = createReducer(utilStoreStateInitial(), reducer);
